import Utils from '@/common/utils';

import type { TAnalyticsNotesFilter } from '../types/analytics-notes';

import links from '@/utils/links';

/**
 * Генерирует и возвращает файл Excel для страницы «Аналитическая записка по внешней торговле РФ по странам мира (годовая)».
 * @param params — фильтр (periods, country, costType)
 * @param fileName — наименование файла
 */
export const exportExcelYearly = (params: TAnalyticsNotesFilter, fileName: string) => {
  return Utils.downloadFile(links.ved.annualForeignTrade.exportExcel, fileName, params, true, 'post');
};

/**
 * Генерирует и возвращает файл Excel для страницы «Аналитическая записка по внешней торговле РФ по странам мира (месячная)».
 * @param params — фильтр (periods, country, costType)
 * @param fileName — наименование файла
 */
export const exportExcelMonthly = (params: TAnalyticsNotesFilter, fileName: string) => {
  return Utils.downloadFile(links.ved.monthlyForeignTrade.exportExcel, fileName, params, true, 'post');
};
